var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBreakfast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 31,
    viewBox: "0 0 36 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.90918 25.4897C4.33099 28.5414 10.3627 30.2005 17.9247 30.2005C25.42 30.2005 31.5589 28.4438 32.0881 25.5535",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6881 27.2396C23.3716 27.6191 20.7588 27.8325 17.9942 27.8325C8.46349 27.8325 0.737305 25.2958 0.737305 22.1663C0.737305 20.5155 2.88765 19.0295 6.31883 17.9939",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8912 18.06C33.1996 19.0924 35.2626 20.5512 35.2626 22.1681C35.2626 23.9359 32.7966 25.5148 28.9326 26.5539",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29199 18.5941V20.3671C6.29199 22.2208 11.5249 24.3143 17.9802 24.3143C24.4353 24.3143 29.6682 22.2208 29.6682 20.3671V18.5941",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9869 16.6883C29.0539 17.1946 29.6682 17.7884 29.6682 18.4234C29.6682 20.2769 24.4351 21.7795 17.98 21.7795C11.5249 21.7795 6.29199 20.2769 6.29199 18.4234C6.29199 18.0531 6.50088 17.6968 6.8865 17.3638",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0967 17.7761C27.6677 17.0825 28.6053 16.2549 28.6053 15.4703V13.6973",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2373 13.6956V15.4687C5.2373 17.3222 10.4702 19.4158 16.9254 19.4158C19.5103 19.4158 21.8991 19.0801 23.8344 18.5585",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15271 16.0339C8.04528 15.7501 6.83159 15.3894 5.92459 14.6612C5.23075 14.1044 4.9952 13.3205 5.67319 12.6224C6.30028 11.9767 7.22631 11.6216 8.0616 11.3424",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.049 16.3877C19.4677 16.9579 15.8566 17.0274 12.2139 16.598",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4674 12.9973C28.5629 13.17 28.6125 13.3471 28.6125 13.5276C28.6125 14.3029 27.6968 15.0168 26.1592 15.5851",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1592 13.7153C29.1718 12.9363 31.141 11.7089 31.141 10.5718V8.79871",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1592 14.5122C21.1538 14.4891 22.1153 14.4168 23.028 14.3043",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76855 8.79773V10.5708C7.76855 12.1852 11.7379 13.9816 17.027 14.4184",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3879 6.85864C30.4997 7.37224 31.1418 7.9785 31.1418 8.6278C31.1418 9.7551 29.2062 10.7525 26.2373 11.3611",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0284 11.915C11.7386 11.594 7.76855 10.2458 7.76855 8.63136C7.76855 8.43594 7.82669 8.24441 7.93835 8.05817",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0511 11.8259C22.1316 11.9109 21.1624 11.9641 20.1592 11.9809",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2686 8.76304C28.3836 8.00797 29.6918 7.02116 29.6918 6.09437V4.32123",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29199 4.32318V6.0963C6.29199 7.85379 10.9964 9.82706 16.9866 10.0269",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6682 4.15564C29.6682 2.30217 24.4353 0.79953 17.98 0.79953C11.5249 0.79953 6.29199 2.30217 6.29199 4.15564C6.29199 5.67328 9.80005 6.95557 14.6147 7.37058C16.0061 7.49043 17.0773 8.64905 17.0773 10.0454V14.1106C17.0773 14.9202 17.7069 15.6097 18.5158 15.6386C19.3654 15.6687 20.0634 14.9891 20.0634 14.1464V11.3358C20.0634 10.5104 20.7174 9.8137 21.5427 9.8062C22.3352 9.79911 22.9851 10.4097 23.0438 11.1854V17.2309C23.0438 18.0556 23.7123 18.724 24.5368 18.724C25.3613 18.724 26.0298 18.0556 26.0298 17.231V8.50558C26.0298 7.42265 26.6838 6.45314 27.6799 6.02862C28.9354 5.4937 29.6682 4.84919 29.6682 4.15564Z",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6279 2.99915C12.239 3.13804 9.87793 3.76304 9.87793 3.76304",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakfast);
export default __webpack_public_path__ + "static/media/breakfast.16a5968fe51318fcb527b08446a49f15.svg";
export { ForwardRef as ReactComponent };